import { categories } from 'data/categories'

export const dashboardApi = {
  getCategories() {
    return Promise.resolve(categories)
  },
  setResult(param: { categoryId: string; taskId: string; result: number }) {
    return Promise.resolve(param) // it would be good to get attempts quantity from backend
  },
  resetResult() {
    return Promise.resolve()
  },
}
